import { render } from "./BasicSettingsACSystem.vue?vue&type=template&id=7980a2b2&scoped=true&ts=true"
import script from "./BasicSettingsACSystem.vue?vue&type=script&lang=ts"
export * from "./BasicSettingsACSystem.vue?vue&type=script&lang=ts"

import "./BasicSettingsACSystem.vue?vue&type=style&index=0&id=7980a2b2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7980a2b2"]])

export default __exports__